export const ERROR_TYPE = {
  NETWORK_ERROR: 'NetworkError',
  BOUNDARY_ERROR: 'BoundaryError',
};
